'use client';

import {cn} from '@/lib/utils';

export default function Height(Prop: {moduleSlug: string}) {
  const {moduleSlug} = Prop;
  const styles = moduleSlug.split('|');

  const sizes: string[] = [];
  styles.map((style) => {
    style.includes(':') ? sizes.push(style.split(':')[0]) : null;
  });

  return (
    <>
      {styles.map((style, i) => {
        const size = style.includes(':') ? style.split(':')[0] : null;
        const height = style.includes(':') ? style.split(':')[1] : style;
        return (
          <div
            key={i}
            className={cn(
              sizes
                .map((s) => {
                  return s != size ? `${s}:hidden` : `${s}:flex`;
                })
                .join(' '),
              size && 'hidden'
            )}
            style={{height}}
          ></div>
        );
      })}
    </>
  );
}
